import React from 'react';
import { X, ArrowUpRight } from 'lucide-react';

const KEY = 'movember2026_dismissed';
const inNovember = () => new Date().getMonth() === 10;
export const movemberActive = () => inNovember() && localStorage.getItem(KEY) !== '1';

const Moustache = () => (
  <svg viewBox="0 0 64 24" className="h-4 w-10 shrink-0 fill-[#F5F5DC]" aria-hidden="true">
    <path d="M32 9c-3-5-9-7-14-5-4 2-6 6-10 7-3 1-6 0-8-2 1 6 6 11 13 11 8 0 13-5 19-8 6 3 11 8 19 8 7 0 12-5 13-11-2 2-5 3-8 2-4-1-6-5-10-7-5-2-11 0-14 5z" />
  </svg>
);

export const MovemberBanner = ({ onClose }) => {
  const close = () => { localStorage.setItem(KEY, '1'); onClose(); };
  return (
    <div data-testid="movember-banner" className="relative mt-14 sm:mt-16 lg:mt-20 bg-[#111] border-y border-[#2a2a2a]">
      <div className="max-w-3xl mx-auto pl-4 pr-11 sm:px-12 py-2.5 sm:py-5 flex flex-row sm:flex-col items-center sm:text-center gap-3 sm:gap-2.5">
        <Moustache />
        <p className="flex-1 sm:flex-none text-white text-sm sm:text-base font-semibold" data-testid="movember-banner-title">
          BWGELA supports Movember
        </p>
        <p className="hidden sm:block text-sm text-[#B8B8B8] leading-relaxed" data-testid="movember-banner-text">
          Raising awareness of prostate cancer, testicular cancer, mental health and suicide prevention. Please visit their website, explore their resources and get involved.
        </p>
        <a href="https://movember.com" target="_blank" rel="noopener noreferrer" data-testid="movember-banner-link"
          className="sm:mt-1 shrink-0 inline-flex items-center gap-1 px-3 sm:px-4 py-1.5 rounded-full bg-[#F5F5DC] text-black text-[13px] sm:text-sm font-medium hover:bg-white transition-colors">
          <span className="sm:hidden">Visit</span><span className="hidden sm:inline">Visit Movember</span> <ArrowUpRight className="h-4 w-4" />
        </a>
      </div>
      <button type="button" onClick={close} aria-label="Close Movember banner" data-testid="movember-banner-close"
        className="absolute top-1/2 -translate-y-1/2 sm:translate-y-0 sm:top-3 right-2 sm:right-5 p-1.5 text-gray-500 hover:text-white transition-colors">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
